import * as form01 from './v2-form01.js';
import * as form02 from './v2-form02.js';
import * as form03 from './v2-form03.js';
import * as form04 from './v2-form04.js';
import * as form05 from './v2-form05.js';
import * as formXX from './v2-formXX.js';

//import * as formXX from './v2-formXX.js';

/*
import * as form01 from '../v2-templates/form01/v2-form.js';
import * as form02 from '../v2-templates/form02/v2-form.js';
import * as form03 from '../v2-templates/form03/v2-form.js';
import * as form04 from '../v2-templates/form04/v2-form.js';
import * as form05 from '../v2-templates/form05/v2-form.js';
import * as formXX from '../v2-templates/formXX/v2-formXX.js';*/


let imported; // = form01
let location = window.location.href.match(/form(\d{2}|XX)/i);
switch (location[0].toLowerCase()) {
    case 'form02':
        imported = form02
        break;
    case 'form03':
        imported = form03
        break;
    case 'form04':
        imported = form04
        break;
    case 'form05':
        imported = form05
        break;
    case 'formxx':
        imported = formXX
        break;
    default:
        imported = form01
        break;
}

let targeturl = imported.targeturl;
let fet$unexpectedError = imported.fet$unexpectedError;
let fet$showSubmitSuccess = imported.fet$showSubmitSuccess;
let fet$redirect = imported.fet$redirect;
let fet$showSubmitError = imported.fet$showSubmitError;
let fet$onSubmit = imported.fet$onSubmit;
let fet$langsAvailable = imported.fet$langsAvailable;
let fet$onRendering = imported.fet$onRendering;
let fet$onProgress = imported.fet$onProgress;
let onLangChanged = imported.onLangChanged;
let toggleError = imported.toggleError;
let fet$onValidationPerformed = imported.fet$onValidationPerformed;
let fet$onUnrecoverableError = imported.fet$onUnrecoverableError;

export {
    targeturl, fet$unexpectedError, fet$showSubmitSuccess, fet$redirect,
    fet$showSubmitError, fet$onSubmit, fet$langsAvailable,
    fet$onRendering, fet$onProgress, onLangChanged, toggleError,
    fet$onValidationPerformed, fet$onUnrecoverableError
}